/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IInstitution } from 'app/shared/model/institution.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPackageSubscriber } from 'app/shared/model/package-subscriber.model';
import { InsurancePolicyStatus } from 'app/shared/model/enumerations/insurance-policy-status.model';
import { InsuranceType } from 'app/shared/model/enumerations/insurance-type.model';

export interface IInsurancePolicy {
  id?: string;
  startDate?: number | null;
  expiryDate?: number | null;
  policyNumber?: string | null;
  allowedMoney?: number | null;
  usedMoney?: number | null;
  status?: keyof typeof InsurancePolicyStatus | null;
  insuranceType?: keyof typeof InsuranceType | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  employerName?: string | null;
  lastUpdateReason?: string | null;
  provider?: IInstitution;
  patient?: IGlucoUser;
  subscriber?: IPackageSubscriber | null;
}

export const defaultValue: Readonly<IInsurancePolicy> = {
  active: false,
};
